import { themeWorkspace } from "../../theme-node";

export function init() {
  return {
    kind: "category",
    name_universal: "analysis",
    name: "%{BKY_CATANALYSIS}",
    colour: themeWorkspace.categoryStyles.analysis_category.colour,
    imageName: "/toolbox-imgs/functions.svg",
    id: "101",
    contents: [
      {
        kind: "label",
        text: "%{BKY_LABEL_FUNCTIONS}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "math_single",
        fields: {
          OP: "ROOT",
        },
        inputs: {
          NUM: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 9,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "math_trig",
        fields: {
          OP: "SIN",
        },
        inputs: {
          NUM: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 45,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "math_atan2",
        inputs: {
          X: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          Y: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "random_polynom",
        inputs: {
          degree: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 3,
              },
            },
          },
          callback: {
            block: {
              type: "random_number",
              fields: {
                type: "integer",
              },
              inputs: {
                min: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 1,
                    },
                  },
                },
                max: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 100,
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "polynom_with_coefficients",
        inputs: {
          list: {
            block: {
              type: "lists_create_with",
              inline: true,
              extraState: {
                itemCount: 3,
              },
              inputs: {
                ADD0: {
                  block: {
                    type: "math_number",
                    fields: {
                      NUM: 4,
                    },
                  },
                },
                ADD1: {
                  block: {
                    type: "math_number",
                    fields: {
                      NUM: 2,
                    },
                  },
                },
                ADD2: {
                  block: {
                    type: "math_number",
                    fields: {
                      NUM: 1,
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "expression",
        inputs: {
          expression: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "sin(2*x)",
              },
            },
          },
        },
      },
      {
        kind: "label",
        text: "%{BKY_LABEL_TOOLS}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "degree",
        inputs: {
          variable: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "x",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "coefficients",
        inputs: {
          variable: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "x",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "math_arithmetic",
        fields: {
          OP: "ADD",
        },
        inputs: {
          A: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
            block: {
              type: "polynom_with_coefficients",
              inputs: {
                list: {
                  block: {
                    type: "lists_create_with",
                    inline: true,
                    extraState: {
                      itemCount: 3,
                    },
                    inputs: {
                      ADD0: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: 4,
                          },
                        },
                      },
                      ADD1: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: 2,
                          },
                        },
                      },
                      ADD2: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: 1,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          B: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
            block: {
              type: "polynom_with_coefficients",
              inputs: {
                list: {
                  block: {
                    type: "lists_create_with",
                    inline: true,
                    extraState: {
                      itemCount: 2,
                    },
                    inputs: {
                      ADD0: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: 5,
                          },
                        },
                      },
                      ADD1: {
                        block: {
                          type: "math_number",
                          fields: {
                            NUM: -1,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "derivative",
        inputs: {
          expression: {
            block: {
              type: "expression",
              inputs: {
                expression: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "x^2+x",
                    },
                  },
                },
              },
            },
          },
          variable: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "x",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "primitive",
        inputs: {
          expression: {
            block: {
              type: "expression",
              inputs: {
                expression: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "x^2+x",
                    },
                  },
                },
              },
            },
          },
          variable: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "x",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "integral",
        inputs: {
          expression: {
            block: {
              type: "expression",
              inputs: {
                expression: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "x^2+x",
                    },
                  },
                },
              },
            },
          },
          variable: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "x",
              },
            },
          },
          inf: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 2,
              },
            },
          },
          sup: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 2,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "evaluate",
        inputs: {
          expression: {
            block: {
              type: "expression",
              inputs: {
                expression: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "x^2+x",
                    },
                  },
                },
              },
            },
          },
          variable: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "x",
              },
            },
          },
          value: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 2,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "simplify_algebrite",
        inputs: {
          expression: {
            block: {
              type: "expression",
              inputs: {
                expression: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "1+2+3+2x-3x",
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "expand_algebrite",
        inputs: {
          expression: {
            block: {
              type: "expression",
              inputs: {
                expression: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "(a+b)^2",
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "label",
        text: "%{BKY_LABEL_GRAPHIC}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "variables_set",
        inline: false,
        fields: {
          VAR: {
            name: "graphic",
            type: "",
          },
        },
        inputs: {
          VALUE: {
            block: {
              type: "board_geometric",
              fields: {
                axes_type: "xy",
                grid: true,
                showNavigation: false,
              },
              inputs: {
                xmin: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: -10,
                    },
                  },
                },
                xmax: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 10,
                    },
                  },
                },
                ymin: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: -10,
                    },
                  },
                },
                ymax: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 10,
                    },
                  },
                },
              },
            },
          },
        },
        next: {
          block: {
            type: "display_element",
            inputs: {
              object: {
                block: {
                  type: "variables_get",
                  fields: {
                    VAR: {
                      name: "graphic",
                      type: "",
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "draw_in_board",
        fields: {
          board_variable: {
            name: "graphic",
            type: "",
          },
        },
        inputs: {
          figure: {
            block: {
              type: "graph_of_function",
              inputs: {
                expression: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "x^2",
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "graph_of_function",
        inputs: {
          expression: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "x^2",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "graph_of_function_interval",
        inputs: {
          expression: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "sin(x)",
              },
            },
          },
          left: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          right: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 2,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "area_under_function_interval",
        inputs: {
          expression: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "sin(x)",
              },
            },
          },
          left: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 0,
              },
            },
          },
          right: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 2,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "tangent",
        inputs: {
          point: {
            block: {
              type: "point",
              extraState: { displaymoreOptions: true },
              fields: {
                moreOptions: true,
                withLabel: true,
                showInfobox: false,
                fixed: false,
              },
              inputs: {
                name: {
                  shadow: {
                    type: "text",
                    fields: { TEXT: "P" },
                  },
                },
                x: {
                  shadow: {
                    type: "math_number",
                    fields: { NUM: 1 },
                  },
                },
                y: {
                  shadow: {
                    type: "math_number",
                    fields: { NUM: 1 },
                  },
                },
                attractors: {
                  shadow: {
                    type: "math_number",
                    fields: { NUM: 0 },
                  },
                  block: {
                    type: "graph_of_function",
                    inputs: {
                      expression: {
                        shadow: {
                          type: "text",
                          fields: { TEXT: "x^2" },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "lagrange_interpolation",
        inputs: {
          points: {
            block: {
              type: "lists_create_with",
              extraState: {
                itemCount: 3,
              },
              inputs: {
                ADD0: {
                  block: {
                    type: "point",
                    extraState: {
                      displaymoreOptions: false,
                    },
                    fields: {
                      moreOptions: false,
                    },
                    inputs: {
                      name: {
                        shadow: {
                          type: "text",
                          fields: {
                            TEXT: "A",
                          },
                        },
                      },
                      x: {
                        shadow: {
                          type: "math_number",
                          fields: {
                            NUM: -1,
                          },
                        },
                      },
                      y: {
                        shadow: {
                          type: "math_number",
                          fields: {
                            NUM: 1,
                          },
                        },
                      },
                    },
                  },
                },
                ADD1: {
                  block: {
                    type: "point",
                    extraState: {
                      displaymoreOptions: false,
                    },
                    fields: {
                      moreOptions: false,
                    },
                    inputs: {
                      name: {
                        shadow: {
                          type: "text",
                          fields: {
                            TEXT: "B",
                          },
                        },
                      },
                      x: {
                        shadow: {
                          type: "math_number",
                          fields: {
                            NUM: 0,
                          },
                        },
                      },
                      y: {
                        shadow: {
                          type: "math_number",
                          fields: {
                            NUM: 0,
                          },
                        },
                      },
                    },
                  },
                },
                ADD2: {
                  block: {
                    type: "point",
                    extraState: {
                      displaymoreOptions: false,
                    },
                    fields: {
                      moreOptions: false,
                    },
                    inputs: {
                      name: {
                        shadow: {
                          type: "text",
                          fields: {
                            TEXT: "C",
                          },
                        },
                      },
                      x: {
                        shadow: {
                          type: "math_number",
                          fields: {
                            NUM: 1,
                          },
                        },
                      },
                      y: {
                        shadow: {
                          type: "math_number",
                          fields: {
                            NUM: 1,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "erase_in_board",
        fields: {
          figure_variable: {
            name: "figure",
            type: "",
          },
          board_variable: {
            name: "graphic",
            type: "",
          },
        },
      },
    ],
  };
}
